import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationsFI from './locales/fi.json';
import translationsEN from './locales/en.json';
import translationsSV from './locales/sv.json';
import translationsFR from './locales/fr.json';

const resources = {
  fi: { translation: translationsFI },
  en: { translation: translationsEN },
  sv: { translation: translationsSV },
  fr: { translation: translationsFR }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fi', // Finnois par défaut
    lng: 'fi', // Force le finnois au démarrage
    supportedLngs: ['fi', 'en', 'sv', 'fr'],
    detection: {
      order: ['localStorage', 'navigator'], // Cherche d'abord dans localStorage, puis navigateur
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;